import React from 'react';
import ReactECharts from 'echarts-for-react';
import './HouseholdElectrificationChart.scss';

const HouseholdElectrificationChart = () => {
  // Sample data for household electrification progress
  const chartOption = {
    title: {
      text: null
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross'
      },
      formatter: function(params) {
        let tooltip = '<b>' + params[0].axisValue + '</b><br/>';
        params.forEach(function(item) {
          tooltip += '<span style="color:' + item.color + '">●</span> ' + 
                    item.seriesName + ': ' + item.value + '%<br/>';
        });
        return tooltip;
      }
    },
    legend: {
      data: ['Urban Electrification', 'Rural Electrification', 'National Average'],
      top: 10,
      textStyle: {
        fontSize: 12,
        fontFamily: 'Spartan, sans-serif'
      }
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      top: '15%',
      containLabel: true
    },
    xAxis: {
      type: 'category',
      data: ['2017', '2018', '2019', '2020', '2021', '2022', '2023'],
      axisLine: {
        lineStyle: {
          color: '#e5e5e5'
        }
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#666',
        fontSize: 12,
        fontFamily: 'Spartan, sans-serif'
      }
    },
    yAxis: {
      type: 'value',
      name: 'Electrification Rate (%)',
      nameLocation: 'middle',
      nameGap: 50,
      min: 0,
      max: 100,
      interval: 20,
      axisLine: {
        lineStyle: {
          color: '#e5e5e5'
        }
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#666',
        fontSize: 12,
        fontFamily: 'Spartan, sans-serif'
      },
      nameTextStyle: {
        color: '#666',
        fontSize: 12,
        fontFamily: 'Spartan, sans-serif'
      },
      splitLine: {
        lineStyle: {
          color: '#f0f0f0'
        }
      }
    },
    series: [
      {
        name: 'Urban Electrification',
        type: 'line',
        data: [85, 87, 89, 91, 93, 94, 95],
        smooth: true,
        lineStyle: {
          color: '#4CAF50',
          width: 3
        },
        itemStyle: {
          color: '#4CAF50'
        },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(76, 175, 80, 0.3)'
            }, {
              offset: 1, color: 'rgba(76, 175, 80, 0.1)'
            }]
          }
        }
      },
      {
        name: 'Rural Electrification',
        type: 'line',
        data: [25, 28, 32, 38, 45, 52, 58],
        smooth: true,
        lineStyle: {
          color: '#FF9800',
          width: 3
        },
        itemStyle: {
          color: '#FF9800'
        },
        areaStyle: {
          color: {
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: 'rgba(255, 152, 0, 0.3)'
            }, {
              offset: 1, color: 'rgba(255, 152, 0, 0.1)'
            }]
          }
        }
      },
      {
        name: 'National Average',
        type: 'line',
        data: [55, 58, 61, 65, 69, 73, 77],
        smooth: true,
        lineStyle: {
          color: '#2196F3',
          width: 3,
          type: 'dashed'
        },
        itemStyle: {
          color: '#2196F3'
        }
      }
    ]
  };

  return (
    <div className="household-electrification-chart">
      <div className="section-header">
        <h3 className="section-title">Household Electrification Progress</h3>
        <p className="section-subtitle">Year-on-year progress on household electrification</p>
      </div>
      
      <div className="chart-container">
        <ReactECharts 
          option={chartOption} 
          style={{ height: '300px', width: '100%' }}
        />
      </div>
    </div>
  );
};

export default HouseholdElectrificationChart;
